import Microlink from '@microlink/react';
import { BsFilePdf } from 'react-icons/bs';
// --------open-pdf------------
const openFilePreview = (url) => {
  const fileExtension = url.split(".").pop().toLowerCase();

  if (["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)) {
    const previewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
    window.open(previewUrl, "_blank");
  } else {
    window.open(url, "_blank");
  }
};
//--------in-use-message-list--it-is-check-link-or-text------------------
const isLink = (message) => {
  if (!message) return '';
  const urlPattern = /(https?:\/\/[^\s]+)/gi;
  const urlMatch = message.match(urlPattern);

  if (urlMatch) {
    return (
      <>
        <Microlink
          url={urlMatch[0]}
          // size="large"
          // media="image"
          // media='logo'
          target="_blank"
        />
        <a href={urlMatch[0]} target="_blank" rel="noopener noreferrer">
          {urlMatch[0]}
        </a>
      </>)
  } else {
    return <p>{message}</p>;
  }
};

// ---------handle-preview-file-image-or-pdf----in-chat-section------------
export const previewFiles = (url) => {
  if (!url) return null;

  const fileExtension = url.split('.').pop().toLowerCase();
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'png'].includes(fileExtension);
  const isPDF = fileExtension === 'pdf';

  if (isImage) {
    return <img className="pastImage" src={url} alt="attachment preview" />;
  } else if (isPDF) {
    return <BsFilePdf size={50} color="red" />;
  } else {
    return <p>Unsupported file type</p>;
  }
};
//-------------reply-preview-only-file---image-or-pdf-----------------
const renderReplyAttachment = (url) => {
  if (!url) return null
  const fileExtension = url?.split(".").pop().toLowerCase();
  const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);
  const isPDF = fileExtension === "pdf";

  if (isImage) {
    return (
      <img
        src={url}
        alt="reply"
        style={{
          maxWidth: "100px",
          borderRadius: "6px",
          marginTop: "4px",
          cursor: "pointer",
        }}
      // onClick={() => handleViewProfile(file.url)}
      />
    );
  } else if (isPDF) {
    return (
      <div
        // onClick={() => handleViewProfile(file.url)}
        style={{ marginTop: "5px", cursor: "pointer" }}
      >
        <BsFilePdf size={30} color="red" title="PDF Preview" />
      </div>
    );
  }

  return (
    <div style={{ fontSize: "0.8em", color: "#999" }}>
      Unsupported attachment
    </div>
  );
};


export const renderReply = (data, scrollToMessage = () => { }) => {
  if (!data) return null
  const replyData = data?.replyOf;
  if (!replyData) return null;

  return (
    <div
      className="reply-message"
      onClick={() => scrollToMessage(replyData._id)}
      style={{
        padding: "8px",
        borderLeft: "3px solid #ccc",
        marginBottom: "5px",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: "bold", fontSize: "0.9em" }}>
        {replyData?._sender?.fullName}
      </div>
      {replyData?.message && (
        <div className="reply-text" style={{ fontSize: "0.85em" }}>
          {replyData.message}
        </div>
      )}
      {replyData?.attachments?.length > 0 && (
        <div className="reply-image-preview">
          {renderReplyAttachment(replyData.attachments[0].url)}
        </div>
      )}
    </div>
  );
};
// --------here-check-if-link-or-normal-message-------------
export const renderMessage = (data) => {
  if (!data) return null;
  return isLink(data.message);
};


// --------here-show-image-and-pdf-------------
export const renderAttachments = (data, handleViewProfile = () => { }) => {
  if (!data) return null
  if (data.attachments?.length > 0) {
    return data.attachments.map((file) => {
      const fileType = file.type?.toUpperCase();
      if (fileType === "IMAGE") {
        return (
          <img
            key={file._id}
            src={file.url}
            alt="attachment"
            onClick={() => handleViewProfile(file.url)}
            style={{
              maxWidth: "200px",
              maxHeight: "200px",
              marginTop: "5px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          />
        );
      } else if (fileType === "DOCUMENTS") {
        return (
          <div key={file._id} style={{ marginTop: "8px", cursor: "pointer" }} onClick={() => openFilePreview(file.url)}>
            <BsFilePdf size={50} color="red" title="Open PDF" />
          </div>
        );
      }

      // You can add a fallback for other file types if needed
      return (
        <div key={file._id} style={{ fontSize: "0.9em", color: "#999" }}>
          Unsupported file type
        </div>
      );
    });
  }
  return null;
}